(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.setPreHeaderHeightHandler = this.setPreHeaderHeight.bind(this);

      this.setHeaderHeight();
      this.setPreHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightHandler);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setPreHeaderHeightHandler);
      window.addEventListener('resize', this.setPreHeaderHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.footerIsVisible = false;
      this.createFooterObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setPreHeaderHeight() {
      if (!this.header) return;

      let preHeaderHeight = 0;
      const preHeaderSections = [];
      let previousSection = this.header.previousElementSibling;

      while (previousSection && previousSection.classList.contains('shopify-section-group-header-group')) {
        preHeaderSections.unshift(previousSection);
        previousSection = previousSection.previousElementSibling;
      }

      preHeaderSections.forEach((section) => {
        section.classList.add('header-preheader-section');
        section.style.setProperty('--header-preheader-top', `${preHeaderHeight}px`);
        preHeaderHeight += section.offsetHeight;
      });

      document.documentElement.style.setProperty('--header-preheader-height', `${preHeaderHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setPreHeaderHeightHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    createFooterObserver() {
      const footer = document.querySelector('footer.footer');
      if (!footer) return;

      const observer = new IntersectionObserver((entries) => {
        this.footerIsVisible = entries[0].isIntersecting;
        this.header.classList.add('footer-transition-active');
        this.header.classList.toggle('header-hide-for-footer', this.footerIsVisible);
      }, { threshold: 0 });

      observer.observe(footer);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const boundsTop = Number.isFinite(this.headerBounds.top) ? this.headerBounds.top : 0;
      const boundsBottom = Number.isFinite(this.headerBounds.bottom) ? this.headerBounds.bottom : 0;
      const triggerPoint = boundsBottom || this.header.offsetHeight || 1;

      if (scrollTop >= triggerPoint) {
        /* Past the header - show floating sticky header */
        if (!this.header.classList.contains('scrolled-past-header')) {
          this.header.classList.add('animate');
        }
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= boundsTop) {
        /* Back to top - reset to normal header */
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.footerIsVisible) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
